import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=c2db6090&scoped=true&"
import script from "./DrawerMenu.vue?vue&type=script&lang=js&"
export * from "./DrawerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=c2db6090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db6090",
  null
  
)

export default component.exports